import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { whoweare } from "../../Assets.tsx";

/* Theme  : same as Our Values.
   Colours: text #4e5356 | buttons #2596be | headings #4573a6
   Fonts  : Ubuntu Bold (headings) / Open Sans Regular (body)
   Icons  : white stroke on gradient tiles, so they never disappear on hover. */

const STYLES = `
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@400&family=Ubuntu:wght@700&display=swap");
.wa{--text:#4e5356;--head:#4573a6;--btn:#2596be;--line:#c9dde8;--tint:#eef6fa;
  position:relative;overflow:hidden;padding:90px 24px;font-family:"Open Sans",sans-serif;font-weight:400;color:var(--text);
background: #ffffff;
.wa::before {
  content: none;
}  background-image:linear-gradient(90deg,rgba(69,115,166,.06) 1px,transparent 1px);background-size:90px 100%}
.wa>*{position:relative}

.wa-grid{display:grid;grid-template-columns:1fr 1.05fr;align-items:center;gap:70px;max-width:1180px;margin:0 auto}

/* ---------- IMAGE ---------- */
.wa-visual{position:relative;padding:0 0 32px 32px}
.wa-back{position:absolute;left:0;bottom:0;width:72%;height:72%;border-radius:30px;background:linear-gradient(135deg,var(--head),var(--btn))}
.wa-dots{position:absolute;right:-16px;top:-20px;width:110px;height:110px;background-image:radial-gradient(var(--btn) 2px,transparent 2px);background-size:16px 16px;opacity:.4}
.wa-imgbox{position:relative;overflow:hidden;border-radius:26px;height:460px;border:6px solid #fff;box-shadow:0 36px 64px -34px rgba(69,115,166,.8)}
.wa-imgbox img{width:100%;height:100%;object-fit:cover;display:block;transition:transform 1s cubic-bezier(.2,.8,.2,1)}
.wa-visual:hover .wa-imgbox img{transform:scale(1.06)}
.wa-badge{position:absolute;right:-20px;bottom:64px;z-index:3;display:flex;align-items:center;gap:12px;padding:11px 16px;border-radius:16px;background:#fff;
  border:1px solid var(--line);box-shadow:0 18px 30px -16px rgba(69,115,166,.7);animation:waFloat 5s ease-in-out infinite}
.wa-badge .ico{width:40px;height:40px;border-radius:12px;display:flex;align-items:center;justify-content:center;background:linear-gradient(135deg,var(--head),var(--btn))}
.wa-badge b{display:block;font-family:"Ubuntu",sans-serif;font-size:19px;line-height:1.1;color:var(--head)}
.wa-badge small{font-size:12px;color:var(--text)}

/* entrance */
.wa-visual,.wa-text{transition:opacity .9s cubic-bezier(.2,.8,.2,1),transform .9s cubic-bezier(.2,.8,.2,1)}
.wa-grid:not(.in) .wa-visual{opacity:0;transform:translateX(-70px)}
.wa-grid:not(.in) .wa-text{opacity:0;transform:translateX(70px)}

/* ---------- TEXT ---------- */
.wa-chip{display:inline-block;margin-bottom:14px;padding:6px 18px;border-radius:50px;background:#fff;border:1px solid var(--line);
  color:var(--head);font-size:12px;letter-spacing:2px;text-transform:uppercase}
.wa h2{position:relative;display:inline-block;margin:0 0 24px;font-family:"Ubuntu",sans-serif;font-weight:700;color:var(--head);font-size:clamp(32px,4vw,44px);line-height:1.15;
  cursor:default;transition:color .35s,letter-spacing .35s}
.wa h2:hover{color:var(--btn);letter-spacing:.6px}
.wa h2::after{content:"";position:absolute;left:0;bottom:-10px;height:4px;width:60px;border-radius:4px;background:linear-gradient(90deg,var(--head),var(--btn));
  transition:width .5s cubic-bezier(.2,.8,.2,1)}
.wa h2:hover::after{width:100%}
.wa-text p{margin:0 0 14px;font-size:15.5px;line-height:1.8;color:var(--text)}

.wa-feats{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:14px;margin:24px 0 30px}
.wa-feat{--mx:50%;--my:50%;position:relative;overflow:hidden;padding:18px 14px;border-radius:20px;background:#fff;border:1px solid var(--line);cursor:default;
  box-shadow:0 14px 28px -24px rgba(69,115,166,.55);
  transition:transform .4s cubic-bezier(.3,1.4,.5,1),box-shadow .4s,border-color .4s}
.wa-feat:hover{transform:translateY(-8px);border-color:rgba(37,150,190,.55);box-shadow:0 26px 40px -24px rgba(37,150,190,.7),0 0 0 4px rgba(37,150,190,.08)}
.wa-feat .glow{position:absolute;inset:0;pointer-events:none;opacity:0;transition:opacity .35s;
  background:radial-gradient(180px circle at var(--mx) var(--my),rgba(37,150,190,.16),transparent 70%)}
.wa-feat:hover .glow{opacity:1}
.wa-feat .bar{position:absolute;top:0;left:0;height:4px;width:100%;background:linear-gradient(90deg,var(--head),var(--btn));transform:scaleX(0);transform-origin:left;
  transition:transform .5s cubic-bezier(.2,.8,.2,1)}
.wa-feat:hover .bar{transform:scaleX(1)}
.wa-fico{position:relative;width:46px;height:46px;border-radius:14px;margin-bottom:12px;display:flex;align-items:center;justify-content:center;
  background:linear-gradient(135deg,var(--head),var(--btn));box-shadow:0 12px 20px -10px rgba(37,150,190,.8);transition:transform .5s cubic-bezier(.3,1.6,.5,1)}
.wa-feat:hover .wa-fico{transform:rotate(-8deg) scale(1.1)}
.wa-feat h4{position:relative;margin:0 0 4px;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:16px;color:var(--head)}
.wa-feat span{position:relative;font-size:13px;line-height:1.5;color:var(--text)}

.wa-btn{position:relative;overflow:hidden;z-index:0;display:inline-flex;align-items:center;gap:10px;padding:13px 30px;border:none;border-radius:50px;
  background:var(--btn);color:#fff;font-family:"Open Sans",sans-serif;font-size:15px;cursor:pointer;
  box-shadow:0 14px 24px -14px rgba(37,150,190,.9);transition:transform .35s cubic-bezier(.3,1.6,.5,1),box-shadow .35s}
.wa-btn::before{content:"";position:absolute;inset:0;z-index:-1;background:var(--head);transform:translateX(-101%);transition:transform .45s cubic-bezier(.2,.8,.2,1)}
.wa-btn span{display:inline-block;transition:transform .35s}
.wa-btn:hover{transform:translateY(-3px);box-shadow:0 20px 30px -14px rgba(69,115,166,.9)}
.wa-btn:hover::before{transform:none}
.wa-btn:hover span{transform:translateX(5px)}

@keyframes waFloat{50%{transform:translateY(-10px)}}

@media(max-width:960px){
  .wa{padding:70px 18px}
  .wa-grid{grid-template-columns:1fr;gap:60px}
  .wa-imgbox{height:340px}
  .wa-badge{right:-6px;bottom:48px}
  .wa-feats{grid-template-columns:1fr}
  .wa-feat{display:flex;align-items:center;gap:16px;padding:14px}
  .wa-fico{margin:0;flex:none}
}
@media(prefers-reduced-motion:reduce){
  .wa *,.wa *::before,.wa *::after{animation:none!important;transition:none!important}
  .wa-grid .wa-visual,.wa-grid .wa-text{opacity:1;transform:none}
}
`;

const FEATURES = [
  {
    title: "Technology",
    text: "Cutting edge solutions",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M16 18l6-6-6-6M8 6l-6 6 6 6" />
      </svg>
    ),
  },
  {
    title: "Creativity",
    text: "Ideas turned into impact",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 18h6M10 22h4" />
        <path d="M12 2a7 7 0 00-4 12.7c.6.5 1 1.3 1 2.1V17h6v-.2c0-.8.4-1.6 1-2.1A7 7 0 0012 2z" />
      </svg>
    ),
  },
  {
    title: "Strategy",
    text: "Tailored for growth",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="9" />
        <circle cx="12" cy="12" r="5" />
        <circle cx="12" cy="12" r="1.2" fill="#fff" />
      </svg>
    ),
  },
];

const Feature = ({ item }: { item: (typeof FEATURES)[number] }) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const handleMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    el.style.setProperty("--mx", e.clientX - r.left + "px");
    el.style.setProperty("--my", e.clientY - r.top + "px");
  };
  return (
    <div className="wa-feat" ref={ref} onMouseMove={handleMove}>
      <div className="bar" />
      <div className="glow" />
      <div className="wa-fico">{item.icon}</div>
      <div>
        <h4>{item.title}</h4>
        <span>{item.text}</span>
      </div>
    </div>
  );
};

const WhoWeAre = () => {
  const history = useHistory();
  const gridRef = useRef<HTMLDivElement | null>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setInView(true); observer.disconnect(); } },
      { threshold: 0.2 }
    );
    if (gridRef.current) observer.observe(gridRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="wa">
      <style>{STYLES}</style>

      <div className={"wa-grid" + (inView ? " in" : "")} ref={gridRef}>
        {/* IMAGE */}
        <div className="wa-visual">
          <div className="wa-back" />
          <div className="wa-dots" />
          <div className="wa-imgbox">
            <img src={whoweare} alt="Who We Are" />
          </div>
          <div className="wa-badge">
            <span className="ico">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="8" r="6" />
                <path d="M8.2 13.5L7 22l5-3 5 3-1.2-8.5" />
              </svg>
            </span>
            <div>
              <b>10+ Years</b>
              <small>Of Experience</small>
            </div>
          </div>
        </div>

        {/* TEXT */}
        <div className="wa-text">
          <span className="wa-chip">About ATUM</span>
          <div>
            <h2>Who We Are</h2>
          </div>

          <p>
            At ATUM Information Technology, we are a dedicated team of innovators
            focused on turning ideas into cutting edge solutions that drive
            business success. Combining technology, creativity, and strategic
            thinking, we deliver tailored solutions that enhance growth,
            efficiency, and impact.
          </p>
          <p>
            Passionate about simplifying complexity, we empower businesses to
            thrive in today’s fast-changing digital world. Our mission is to
            transform visions into reality, making the digital landscape more
            accessible and helping businesses achieve lasting success.
          </p>

          <div className="wa-feats">
            {FEATURES.map((f) => (
              <Feature key={f.title} item={f} />
            ))}
          </div>

          <button className="wa-btn" onClick={() => history.push("/aboutUs")}>
            Read more <span>→</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default WhoWeAre;